import React from 'react';
import FlexComponent from '../FlexComponent';
import { Dropdown } from 'primereact/dropdown';
import CosignerWorkHistoryComponent from './CosignerWorkHistoryComponent';

function CosignerWorkHistory({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  index,
  isNewEntry,
  currentCosigner,
  handleNewEntryChange,
  toast,
}) {
  // Ensure currentCosigner is defined for existing cosigners
  const cosignerData = isNewEntry ? currentCosigner : values.cosigner_list[index] || {};

  return (
    <div style={{ width: '100%', boxShadow : "rgba(0, 0, 0, 0.2) 0px 4px 10px 4px" }} id="workAndIncome">
      <CosignerWorkHistoryComponent
        values={values}
        errors={errors}
        touched={touched}
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        index={index}
        isNewEntry={isNewEntry}
        currentCosigner={cosignerData}
        handleNewEntryChange={handleNewEntryChange}
        isSecondJob={false}
        toast={toast}
      />
      <div className="inputContainerDiv" style={{ textAlign: 'start', width: '40%', padding: '1rem 2.5rem' }}>
        <Dropdown
          id={`cosigner_list.${index}.do_you_have_second_job`}
          value={cosignerData.do_you_have_second_job || ''}
          options={[
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
          ]}
          style={{ width: '100%' }}
          onChange={(e) => {
            if (isNewEntry) {
              handleNewEntryChange('do_you_have_second_job', e.value);
            } else {
              handleChange({
                target: {
                  name: `cosigner_list.${index}.do_you_have_second_job`,
                  value: e.value,
                },
              });
            }
          }}
          showClear={cosignerData.do_you_have_second_job}
          onBlur={handleBlur}
          placeholder="Do you have a second Job?"
        />
      </div>
      {cosignerData.do_you_have_second_job === 'Yes' && (
        <CosignerWorkHistoryComponent
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          setFieldValue={setFieldValue}
          index={index}
          isNewEntry={isNewEntry}
          currentCosigner={cosignerData}
          handleNewEntryChange={handleNewEntryChange}
          isSecondJob={true}
          toast={toast}
        />
      )}
    </div>
  );
}

export default CosignerWorkHistory;